import React, { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const AlertSnackbar = ({ message, onClose, offset = 0 }) => {
  useEffect(() => {
    if (message) {
      const audio = new Audio("/sounds/notification.mp3");
      audio.play().catch(() => {});
    }
  }, [message]);

  return (
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ top: `${offset * 70 + 20}px !important` }}
    >
      <MuiAlert onClose={onClose} severity="info" variant="filled">
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default AlertSnackbar;
